export const MAX_INT32_VALUE = 2147483647
